import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const getDefaultState = () => {
  return {
  }
}

const state = getDefaultState();

const mutations = {
    toggleSidebarDesktop (state) {
      const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
      state.sidebarShow = sidebarOpened ? false : 'responsive'
    },
    toggleSidebarMobile (state) {
      const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
      state.sidebarShow = sidebarClosed ? true : 'responsive'
    },
    set (state, [variable, value]){
      try {
        // let temp = JSON.stringify(value);
        // localStorage.setItem(Vue.prototype.$appType + variable, temp);
        state[variable] = value;
      } catch {
        return false;
      }
    },
    getStorage(state, variable){
        if (localStorage.getItem(Vue.prototype.$appType + variable)){
          try {
            let temp = JSON.parse(localStorage.getItem(Vue.prototype.$appType + variable));
            state[variable] = temp;
          } catch {
            return false
          }
        }
    },
    setDefaultState(state){
      Object.assign(state, getDefaultState());
    }
}

export default new Vuex.Store({
    state,
    mutations
})
